'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _currency_utility = require('../../../packages/common-utilities/src/currency_utility.js');

var _currency_utility2 = _interopRequireDefault(_currency_utility);

var _number_utility = require('../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _fund_stats_data_point = require('./fund_stats_data_point.js');

var _fund_stats_data_point2 = _interopRequireDefault(_fund_stats_data_point);

var _reactIntl = require('react-intl');

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _sanitize_utility = require('../../../packages/common-utilities/src/sanitize_utility.js');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _ramda = require('ramda');

var _constants = require('../../../packages/common-utilities/src/constants.js');

var _constants2 = _interopRequireDefault(_constants);

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _functional_utility2 = _interopRequireDefault(_functional_utility);

var _formatted_number = require('./global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _fund_utility = require('../../../packages/common-utilities/src/fund_utility');

var _string_utility3 = require('../../../packages/common-utilities/src/string_utility');

var _collection_utility = require('common-utilities/src/collection_utility');

var _number_utility3 = require('common-utilities/src/number_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var FundStatsCard = function (_PureComponent) {
  _inherits(FundStatsCard, _PureComponent);

  function FundStatsCard(props) {
    _classCallCheck(this, FundStatsCard);

    var _this = _possibleConstructorReturn(this, (FundStatsCard.__proto__ || Object.getPrototypeOf(FundStatsCard)).call(this, props));

    _this.renderFundStatsData = _this.renderFundStatsData.bind(_this);
    _this.fundStatsMap = _this.fundStatsMap.bind(_this);
    _this.getRatings = _this.getRatings.bind(_this);
    _this.hasDisclosure = _this.hasDisclosure.bind(_this);
    _this.renderCurrencyCode = _this.renderCurrencyCode.bind(_this);
    return _this;
  }

  _createClass(FundStatsCard, [{
    key: 'doesFormattingRulesContains',
    value: function doesFormattingRulesContains(visibleDataPointName) {
      return (0, _ramda.includes)(visibleDataPointName, (0, _functional_utility.pathOrEmptyArray)(["visibleData", "formattingRules"], this.props));
    }
  }, {
    key: 'renderWamWalDatesForNonUSLiqRole',
    value: function renderWamWalDatesForNonUSLiqRole() {
      var _props = this.props,
          country = _props.country,
          role = _props.role,
          fundShareClassValuationEffectiveDate = _props.fundShareClassValuationEffectiveDate;

      if (country !== "us" && role === _constants2.default.getLIQRole()) {
        return _date_formatter2.default.getDateInDDMMYYYSlashFormat(fundShareClassValuationEffectiveDate);
      }

      return false;
    }
  }, {
    key: 'renderFundStatsData',
    value: function renderFundStatsData() {
      var _this2 = this;

      var isPrint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if ((0, _functional_utility.isNilOrEmpty)(this.props.visibleData.visibleFundStats)) {
        return null;
      }
      var i = 0;
      return (0, _ramda.map)(function (stat) {
        return _this2.fundStatsMap(stat, isPrint, i++);
      }, this.props.visibleData.visibleFundStats);
    }
  }, {
    key: 'renderCurrencyCode',
    value: function renderCurrencyCode() {
      var currencyCode = this.props.currencyCode;
      if (this.props.isDisplayAumInUsd) {
        currencyCode = 'USD';
      } else if (!(0, _ramda.isNil)(this.props.aum) && this.props.aum.currencyCode) {
        currencyCode = this.props.aum.currencyCode;
      }
      return currencyCode;
    }
  }, {
    key: 'renderPrintDisclosures',
    value: function renderPrintDisclosures() {
      var disclosureMarkup = [];
      var disclosures = [];

      if ((0, _functional_utility.isNilOrEmpty)(this.props.visibleData.visibleFundStats)) {
        return null;
      }

      for (var i = 0; i < this.props.visibleData.visibleFundStats.length; i++) {
        disclosureMarkup.push(this.fundStatsMap(this.props.visibleData.visibleFundStats[i]));
      }

      var isVisibleAndHasDisclosure = function isVisibleAndHasDisclosure(n) {
        return !(0, _ramda.isNil)(n) && !(n.props.suppressIfNull === true && ((0, _ramda.isNil)(n.props.value) || n.props.value === "-") && !n.props.intraDayNav) && n.props.suppress !== true && !(0, _ramda.isNil)(n.props.disclosure);
      };

      disclosureMarkup = (0, _ramda.filter)(isVisibleAndHasDisclosure, disclosureMarkup);

      for (var _i = 0; _i < disclosureMarkup.length; _i++) {
        disclosures.push(_react2.default.createElement('div', { key: _i, className: 'margin-bottom-15 text-justified print-page-break',
          dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(disclosureMarkup[_i].props.disclosure) } }));
      }

      return disclosures;
    }
  }, {
    key: 'renderPrintColumns',
    value: function renderPrintColumns() {
      var fundStatsMarkup = this.renderFundStatsData(true);
      var col1 = [];
      var col2 = [];

      if ((0, _functional_utility.isNilOrEmpty)(this.props.visibleData.visibleFundStats)) {
        return null;
      }

      var isVisible = function isVisible(n) {
        return !(0, _ramda.isNil)(n) && !(n.props.suppressIfNull === true && ((0, _ramda.isNil)(n.props.value) || n.props.value === "-") && !n.props.intraDayNav) && n.props.suppress !== true;
      };

      fundStatsMarkup = (0, _ramda.filter)(isVisible, fundStatsMarkup);
      fundStatsMarkup = (0, _ramda.splitAt)(Math.round(fundStatsMarkup.length / 2), fundStatsMarkup);

      if ((0, _ramda.length)(fundStatsMarkup[0]) < 1 && (0, _ramda.length)(fundStatsMarkup[1]) < 1) {
        return null;
      }

      col1 = fundStatsMarkup[0];
      col2 = fundStatsMarkup[1];

      return _react2.default.createElement(
        'div',
        { 'data-testid': 'columns-container', className: 'print-display print-columns-parent',
          style: { "display": "none" } },
        _react2.default.createElement(
          'div',
          { 'data-testid': 'fund-stats-col1', className: 'print-fund-stats-col' },
          col1
        ),
        _react2.default.createElement('div', { className: 'width-percent-20 print-display-inline-block' }),
        _react2.default.createElement(
          'div',
          { 'data-testid': 'fund-stats-col2', className: 'print-fund-stats-col' },
          col2
        )
      );
    }
  }, {
    key: 'fundStatsMap',
    value: function fundStatsMap(key, isPrint, i) {
      var _this3 = this;

      var navDate = (0, _ramda.pathOr)(null, ["nav", "date"], this.props);
      var marketPriceDate = (0, _ramda.pathOr)(null, ["marketPrice", "date"], this.props);
      var latestDividend = (0, _ramda.isNil)((0, _ramda.pathOr)(null, ["latestDividend", "dividendAmount"], this.props)) ? "-" : _number_utility2.default.convertToAmount((0, _ramda.pathOr)(null, ["latestDividend", "dividendAmount"], this.props));

      var period = this.props.isFundMoreThanAYearOld ? _string_utility2.default.renderFormattedLabel("12 Month", "pdp-fund-stats-twelve-month-sub-header") : _string_utility2.default.renderFormattedLabel("Since inception", "pdp-fund-stats-since-inception-sub-header");

      var shouldUseTranslatedMessageToFormatCurrency = this.doesFormattingRulesContains('CURRENCY_FORMATTED_WITH_TRANSLATED_MESSAGE');

      if (key === 'NAV_CHANGE_AMOUNT' && (0, _ramda.isNil)((0, _ramda.pathOr)(null, ["nav", "changeAmount"], this.props)) && (0, _ramda.isNil)((0, _ramda.pathOr)(null, ["nav", "navMovementEffectiveDate"], this.props)) && this.doesFormattingRulesContains('FUND_STATS_NAV_NO_CURRENCY')) {
        return null;
      }

      var shouldGetSinceInceptionReturn = (0, _ramda.includes)("SINCE_INCEPTION_RETURN", this.props.visibleData.visibleFundStats);
      var sinceInceptionReturn = shouldGetSinceInceptionReturn && !(0, _functional_utility.isNilOrEmpty)((0, _ramda.pathOr)(null, ["fund", "shareClass", "fundShareclassPerformanceReturnMonthEnd"], this.props)) ? this.props.fund.shareClass.fundShareclassPerformanceReturnMonthEnd.filter(function (item) {
        return item.returnPeriodIndicator === "INC";
      })[0] || {} : {};

      var oneYrAnnualized = shouldGetSinceInceptionReturn && !(0, _functional_utility.isNilOrEmpty)((0, _ramda.pathOr)(null, ["fund", "shareClass", "fundShareclassPerformanceReturnMonthEnd"], this.props)) ? this.props.fund.shareClass.fundShareclassPerformanceReturnMonthEnd.filter(function (item) {
        return item.returnPeriodIndicator === "1YR";
      })[0] || {} : {};

      var totalAsset = this.props.totalAsset || {};
      var leverageRatio = this.props.leverageRatio || {};
      var grossYieldToMaturity = this.props.grossYieldToMaturity || {};
      var fundStatsMap = {
        "PUBLISHED_AUM": {
          label: _string_utility2.default.renderFormattedLabel('Fund size', "pdp-fund-stats-total-fund-size-label", { role: this.props.role }),
          dataTest: 'fund-stats-fund-size-published-aum',
          key: FundStatsCard.addPrintSuffix('fund-stats-fund-size-published-aum', isPrint),
          date: this.props.aum.date,
          shouldUseOnForDateLabel: false,
          value: _currency_utility2.default.getFundSizeBasedOnRules(this.props.visibleData.formattingRules, this.props.country, this.props.aum.value, this.props.currencyCode, this.props.numberFormat, this.props.role)
        },
        "MARKET_AUM": {
          label: _string_utility2.default.renderFormattedLabel('Total fund size', "pdp-fund-stats-total-fund-size-label", { role: this.props.role, fundType: this.props.fundTypeCode }),
          dataTest: 'fund-stats-total-fund-size',
          key: FundStatsCard.addPrintSuffix('fund-stats-total-fund-size', isPrint),
          date: this.props.aum.date,
          shouldUseOnForDateLabel: false,
          value: _currency_utility2.default.getFundSizeBasedOnRules(this.props.visibleData.formattingRules, this.props.country, this.props.aum.value, this.renderCurrencyCode(), this.props.numberFormat, this.props.role)
        },
        "CUMULATIVE_PERFORMANCE_ONE_YEAR": {
          label: _string_utility2.default.renderFormattedLabel('1 Year Performance', "pdp-fund-stats-cumulative-performance-one-year-label"),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "1 Year Performance", "pdp-fund-stats-cumulative-performance-one-year-label"),
          dataTest: 'fund-stats-cumulative-performance-one-year',
          key: FundStatsCard.addPrintSuffix('fund-stats-cumulative-performance-one-year', isPrint),
          date: (0, _functional_utility.pathOrNull)(["shareClass", "cumulativePerformanceReturns", 0, "effectiveDate"], this.props.fund),
          value: _number_utility2.default.convertDecimalToPercentWith2FixedDecimals((0, _functional_utility.pathOrNull)(["shareClass", "cumulativePerformanceReturns", 0, "oneYear"], this.props.fund), '-', 1),
          disclosure: this.hasDisclosure('pdpDataPoint1yearperformance'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint,
          suppressIfNull: true
        },
        "ANNUALIZED_YIELD": {
          label: _string_utility2.default.renderFormattedLabel('Annualized Yield', "pdp-fund-stats-annualized-yield-label", { fundType: this.props.fundTypeCode }),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "Annualized Yield", "pdp-fund-stats-annualized-yield-label"),
          dataTest: 'fund-stats-annualized-yield',
          key: FundStatsCard.addPrintSuffix('fund-stats-annualized-yield', isPrint),
          date: this.getAnnualizedYieldDate(),
          shouldUseOnForDateLabel: true,
          value: _number_utility2.default.formatToPercentWith2FixedDecimals((0, _ramda.pathOr)(null, ["latestAnnualizedYield", "annualizedDividendYieldPercentage"], this.props)),
          suppressIfNull: true,
          disclosure: (0, _fund_utility.isAUEtfFund)(this.props.country, this.props.fundTypeCode) ? this.hasDisclosure('pdpDataPointDistributionYield') : null,
          tooltip: this.props.tooltip
        },
        "NAV": {
          label: _string_utility2.default.renderFormattedLabel("NAV", "pdp-fund-stats-nav-label", { fundType: this.props.fundTypeCode }),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "NAV", "pdp-fund-stats-nav-label"),
          dataTest: 'fund-stats-nav',
          key: FundStatsCard.addPrintSuffix('fund-stats-nav', isPrint),
          date: navDate,
          shouldUseOnForDateLabel: false,
          disclosure: !(0, _ramda.isNil)(this.props.visibleData.visibleDataPoints) && (0, _ramda.includes)("QUICK_STAT_NAV_REIT_DISCLOSURE", this.props.visibleData.visibleDataPoints) ? this.hasDisclosure('pdpDataPointNAV') : this.hasDisclosure('pdpSummaryNAV'),
          tooltip: this.props.tooltip,
          value: function value() {
            if ((0, _ramda.isNil)((0, _ramda.pathOr)(null, ["nav", "price"], _this3.props))) {
              return "-";
            }

            if (_this3.doesFormattingRulesContains('FUND_STATS_NAV_NO_CURRENCY')) {
              if (_this3.doesFormattingRulesContains('FUND_STATS_NAV_DECIMAL_POINT')) {
                return (0, _number_utility3.convertToAmountWithPreciseRounding)(_this3.props.nav.price, _this3.props.navDecimalPoints, '-', false, true);
              }
              return _number_utility2.default.convertToNumberWithCommas(_this3.props.nav.price);
            } else if (shouldUseTranslatedMessageToFormatCurrency) {
              return _currency_utility2.default.formatCurrencyInRegionTranslatedFormat(_this3.props.country, _this3.props.nav.price, _this3.props.shareclassCurrencyCode, _this3.props.fundTypeCode, _this3.props.navDecimalPoints, null, _this3.props.visibleData);
            }
            return _formatted_number2.default.prototype.numberFormatter(_currency_utility2.default.convertToCurrencyForNav(_this3.props.nav.price, _this3.props.shareclassCurrencyCode, _this3.props.fundTypeCode, _this3.props.country, _this3.props.navDecimalPoints), _this3.props.numberFormat);
          }
        },
        "TRANSACTION_NAV": {
          label: 'Transaction NAV',
          dataTest: 'fund-stats-transaction-nav',
          key: FundStatsCard.addPrintSuffix('fund-stats-transaction-nav', isPrint),
          suppressIfNull: true,
          date: navDate,
          shouldUseOnForDateLabel: false,
          value: _currency_utility2.default.convertToCurrency(this.props.nav.price, this.props.currencyCode)
        },
        "MARKET_BASED_NAV": {
          label: 'Market Based NAV',
          dataTest: 'fund-stats-market-based-nav',
          key: FundStatsCard.addPrintSuffix('fund-stats-market-based-nav', isPrint),
          suppressIfNull: true,
          date: navDate,
          shouldUseOnForDateLabel: false,
          value: _number_utility2.default.convertToNDecimalFixedNumber(this.props.nav.marketValueNavPrice, 4, true)
        },
        "NAV_INTRADAY_WITH_EST_TIMEZONE": {
          label: 'NAV',
          dataTest: 'fund-stats-nav_intraday_est',
          key: FundStatsCard.addPrintSuffix('fund-stats-nav_intraday', isPrint),
          date: navDate,
          shouldUseOnForDateLabel: false,
          currencyCode: this.props.currencyCode,
          intraDayNav: this.props.intraDayNav,
          visibleFundStats: this.props.visibleData.visibleFundStats,
          value: function value() {
            if ((0, _ramda.isNil)((0, _ramda.pathOr)(null, ["nav", "price"], _this3.props))) {
              return "-";
            }
            return _currency_utility2.default.convertToCurrency(_this3.props.nav.price, _this3.props.shareclassCurrencyCode, '-', _this3.props.country);
          }
        },
        "NAV_INTRADAY_WITH_LOCAL_TIMEZONE": {
          label: _string_utility2.default.renderFormattedLabel("NAV", "pdp-fund-stats-nav-label", { fundType: this.props.fundTypeCode }),
          dataTest: 'fund-stats-nav_intraday_local',
          key: FundStatsCard.addPrintSuffix('fund-stats-nav_intraday', isPrint),
          date: navDate,
          shouldUseOnForDateLabel: false,
          currencyCode: this.props.currencyCode,
          intraDayNav: this.props.intraDayNav,
          visibleFundStats: this.props.visibleData.visibleFundStats,
          value: function value() {
            if ((0, _ramda.isNil)((0, _ramda.pathOr)(null, ["nav", "price"], _this3.props))) {
              return "-";
            }
            return _formatted_number2.default.prototype.numberFormatter(_currency_utility2.default.convertToCurrencyForNav(_this3.props.nav.price, _this3.props.shareclassCurrencyCode, _this3.props.fundTypeCode, _this3.props.country, _this3.props.navDecimalPoints), _this3.props.numberFormat);
          },
          visibleDataPoints: this.props.visibleData.visibleDataPoints
        }, "NAV_CHANGE_AMOUNT": {
          label: _string_utility2.default.renderFormattedLabel("-", "pdp-label-nav-display", { fundType: this.props.fundTypeCode }),
          dataTest: 'fund-stats-nav-change-amount',
          key: FundStatsCard.addPrintSuffix('fund-stats-nav-change-amount', isPrint),
          date: this.props.nav.navMovementEffectiveDate,
          shouldUseOnForDateLabel: false,
          value: function value() {
            if ((0, _ramda.isNil)((0, _ramda.pathOr)(null, ["nav", "changeAmount"], _this3.props))) {
              return "-";
            } else if (_this3.doesFormattingRulesContains('FUND_STATS_NAV_NO_CURRENCY')) {
              var decimalPoint = _this3.doesFormattingRulesContains('FUND_STATS_NAV_DECIMAL_POINT') ? _this3.props.navDecimalPoints : 0;
              return (0, _number_utility3.convertToAmountWithPreciseRounding)(_this3.props.nav.changeAmount, decimalPoint, '-', false, true);
            }
            return _formatted_number2.default.prototype.numberFormatter(_currency_utility2.default.convertToCurrencyForNav(_this3.props.nav.changeAmount, _this3.props.shareclassCurrencyCode, _this3.props.fundTypeCode, _this3.props.country, _this3.props.navDecimalPoints), _this3.props.numberFormat);
          }
        },
        "NAV_CHANGE_PERCENTAGE": {
          label: _string_utility2.default.renderFormattedLabel("NAV Change (%)", "pdp-label-nav-percentage", { fundType: this.props.fundTypeCode }),
          dataTest: 'fund-stats-nav-change-percentage',
          key: FundStatsCard.addPrintSuffix('fund-stats-nav-change-percentage', isPrint),
          date: this.props.nav.navMovementEffectiveDate,
          shouldUseOnForDateLabel: false,
          value: _formatted_number2.default.prototype.numberFormatter(_number_utility2.default.formatToPercentWith2FixedDecimals(this.props.nav.changePercentage), this.props.numberFormat)
        },
        "WEEKLY_ROLLING_NAV_HIGH": {
          label: '52 Week Rolling NAV High',
          dataTest: 'fund-stats-weekly-rolling-nav-high',
          key: FundStatsCard.addPrintSuffix('fund-stats-weekly-rolling-nav-high', isPrint),
          date: this.props.nav.highNavPriceDate,
          shouldUseOnForDateLabel: false,
          value: function value() {
            if ((0, _ramda.isNil)((0, _ramda.pathOr)(null, ["nav", "highNavPrice"])(_this3.props))) {
              return "-";
            }
            return _formatted_number2.default.prototype.numberFormatter(_currency_utility2.default.convertToCurrencyForNav(_this3.props.nav.highNavPrice, _this3.props.nav.currencyCode, _this3.props.fundTypeCode, _this3.props.country, _this3.props.navDecimalPoints), _this3.props.numberFormat);
          }
        },
        "WEEKLY_ROLLING_NAV_LOW": {
          label: '52 Week Rolling NAV Low',
          dataTest: 'fund-stats-weekly-rolling-nav-low',
          key: FundStatsCard.addPrintSuffix('fund-stats-weekly-rolling-nav-low', isPrint),
          date: this.props.nav.lowNavPriceDate,
          shouldUseOnForDateLabel: false,
          value: function value() {
            if ((0, _ramda.isNil)((0, _ramda.pathOr)(null, ["nav", "lowNavPrice"], _this3.props))) {
              return "-";
            }
            return _formatted_number2.default.prototype.numberFormatter(_currency_utility2.default.convertToCurrencyForNav(_this3.props.nav.lowNavPrice, _this3.props.nav.currencyCode, _this3.props.fundTypeCode, _this3.props.country, _this3.props.navDecimalPoints), _this3.props.numberFormat);
          }
        },
        "TWELVE_MONTH_NAV_LABEL": {
          label: (0, _ramda.and)(this.doesFormattingRulesContains("FUND_STATS_TWELVE_MONTH_NAV_SHOWS_SINCE_INCEPTION"), this.props.isShareclassMoreThanAYearOld) ? _string_utility2.default.renderFormattedLabel("12 Month NAV", "pdp-fund-stats-twelve-month-nav-sub-header", { period: period, breakingLine: _react2.default.createElement('br', null) }) : _string_utility2.default.renderFormattedLabel("Since Inception", "since-inception"),
          dataTest: '12-month-nav-sub-header',
          key: FundStatsCard.addPrintSuffix('12-month-nav-sub-header', isPrint),
          value: FundStatsCard.isValueMissing(this.props.nav.highNavPrice) && FundStatsCard.isValueMissing(this.props.nav.lowNavPrice) ? null : " ",
          suppressIfNull: FundStatsCard.isValueMissing(this.props.nav.highNavPrice) && FundStatsCard.isValueMissing(this.props.nav.lowNavPrice),
          isSubHeaderTitle: true
        },
        "TWELVE_MONTH_HIGH_NAV": {
          label: _string_utility2.default.renderFormattedLabel('12 Month NAV high', "pdp-fund-stats-twelve-month-high-label", { fundType: this.props.fundTypeCode }),
          dataTest: 'fund-stats-twelve-month-high-nav',
          key: FundStatsCard.addPrintSuffix('fund-stats-twelve-month-high-nav', isPrint),
          date: this.props.nav.highNavPriceDate,
          shouldUseOnForDateLabel: (0, _ramda.includes)("FUND_STATS_DISPLAY_ON_INSTEAD_OF_AS_OFF", this.props.visibleData.formattingRules),
          suppress: this.doesFormattingRulesContains("TWELVE_MONTH_HIGH_NAV_DO_NOT_SUPRESS") ? false : FundStatsCard.isValueMissing(this.props.nav.highNavPrice),
          value: function value() {
            if ((0, _ramda.isNil)((0, _ramda.pathOr)(null, ["nav", "highNavPrice"])(_this3.props))) {
              return "-";
            }
            if (shouldUseTranslatedMessageToFormatCurrency) {
              return _currency_utility2.default.formatCurrencyInRegionTranslatedFormat(_this3.props.country, _this3.props.nav.highNavPrice, _this3.props.nav.currencyCode, _this3.props.fundTypeCode, _this3.props.navDecimalPoints, null, _this3.props.visibleData);
            }
            return _formatted_number2.default.prototype.numberFormatter(_currency_utility2.default.convertToCurrencyForNav(_this3.props.nav.highNavPrice, _this3.props.nav.currencyCode, _this3.props.fundTypeCode, _this3.props.country, _this3.props.navDecimalPoints), _this3.props.numberFormat);
          },
          isGrouped: this.doesFormattingRulesContains('FUND_STATS_NAV_GROUPED'),
          isNonLastSubRow: (0, _ramda.includes)("TWELVE_MONTH_NAV_LABEL", (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleFundStats"], this.props))
        },
        "TWELVE_MONTH_LOW_NAV": {
          label: _string_utility2.default.renderFormattedLabel('12 Month NAV low', "pdp-fund-stats-twelve-month-low-label", { fundType: this.props.fundTypeCode }),
          dataTest: 'fund-stats-twelve-month-low-nav',
          key: FundStatsCard.addPrintSuffix('fund-stats-twelve-month-low-nav', isPrint),
          date: this.props.nav.lowNavPriceDate,
          shouldUseOnForDateLabel: (0, _ramda.includes)("FUND_STATS_DISPLAY_ON_INSTEAD_OF_AS_OFF", this.props.visibleData.formattingRules),
          suppress: this.doesFormattingRulesContains("TWELVE_MONTH_HIGH_NAV_DO_NOT_SUPRESS") ? false : FundStatsCard.isValueMissing(this.props.nav.lowNavPrice),
          value: function value() {
            if ((0, _ramda.isNil)((0, _ramda.pathOr)(null, ["nav", "lowNavPrice"], _this3.props))) {
              return "-";
            }
            if (shouldUseTranslatedMessageToFormatCurrency) {
              return _currency_utility2.default.formatCurrencyInRegionTranslatedFormat(_this3.props.country, _this3.props.nav.lowNavPrice, _this3.props.nav.currencyCode, _this3.props.fundTypeCode, _this3.props.navDecimalPoints, null, _this3.props.visibleData);
            }
            return _formatted_number2.default.prototype.numberFormatter(_currency_utility2.default.convertToCurrencyForNav(_this3.props.nav.lowNavPrice, _this3.props.nav.currencyCode, _this3.props.fundTypeCode, _this3.props.country, _this3.props.navDecimalPoints), _this3.props.numberFormat);
          },
          isGrouped: this.doesFormattingRulesContains('FUND_STATS_NAV_GROUPED'),
          isLastSubRow: (0, _ramda.includes)("TWELVE_MONTH_NAV_LABEL", (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleFundStats"], this.props))
        },
        "CLOSING_PRICE": {
          label: _string_utility2.default.renderFormattedLabel('Closing Price', "pdp-fund-stats-closing-price", { fundTypeCode: this.props.fundTypeCode }),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "12 Month NAV low", "pdp-fund-stats-twelve-month-low-label"),
          dataTest: 'fund-stats-closing-price',
          key: FundStatsCard.addPrintSuffix('fund-stats-closing-price', isPrint),
          date: marketPriceDate,
          shouldUseOnForDateLabel: false,
          value: _currency_utility2.default.convertToCurrency(this.props.marketPrice.amount, this.props.currencyCode),
          disclosure: this.hasDisclosure('pdpDataPointClosingPrice'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint
        },
        "CHANGE_IN_CLOSING_PRICE": {
          label: _string_utility2.default.renderFormattedLabel('Change in Closing Price ($)', "pdp-fund-stats-change-in-closing-price", { fundTypeCode: this.props.fundTypeCode }),
          dataTest: 'fund-stats-change-in-closing-price',
          key: FundStatsCard.addPrintSuffix('fund-stats-change-in-closing-price', isPrint),
          date: marketPriceDate,
          shouldUseOnForDateLabel: false,
          value: _currency_utility2.default.convertToCurrency(this.props.marketPrice.changeAmount, this.props.currencyCode)
        },
        "CHANGE_IN_CLOSING_PRICE_PERCENTAGE": {
          label: _string_utility2.default.renderFormattedLabel('Change in Closing Price (%)', "pdp-fund-stats-change-in-closing-price-percentage", { fundTypeCode: this.props.fundTypeCode }),
          dataTest: 'fund-stats-change-in-closing-price-percentage',
          key: FundStatsCard.addPrintSuffix('fund-stats-change-in-closing-price-percentage', isPrint),
          date: marketPriceDate,
          shouldUseOnForDateLabel: false,
          value: _number_utility2.default.formatToPercentWith2FixedDecimals(this.props.marketPrice.changePercentage)
        },
        "WEEKLY_ROLLING_MARKET_PRICE_HIGH": {
          label: '52 Week Rolling Market Price High',
          dataTest: 'fund-stats-weekly-rolling-market-price-high',
          key: FundStatsCard.addPrintSuffix('fund-stats-weekly-rolling-market-price-high', isPrint),
          date: this.props.nav.highMktNavdate,
          shouldUseOnForDateLabel: false,
          value: function value() {
            if ((0, _ramda.isNil)((0, _ramda.pathOr)(null, ["nav", "highMktNavPrice"])(_this3.props))) {
              return "-";
            }
            return _formatted_number2.default.prototype.numberFormatter(_currency_utility2.default.convertToCurrencyForNav(_this3.props.nav.highMktNavPrice, _this3.props.nav.currencyCode, _this3.props.fundTypeCode, _this3.props.country, _this3.props.navDecimalPoints), _this3.props.numberFormat);
          }
        },
        "WEEKLY_ROLLING_MARKET_PRICE_LOW": {
          label: '52 Week Rolling Market Price Low',
          dataTest: 'fund-stats-weekly-rolling-market-price-low',
          key: FundStatsCard.addPrintSuffix('fund-stats-weekly-rolling-market-price-low', isPrint),
          date: this.props.nav.lowMktNavdate,
          shouldUseOnForDateLabel: false,
          value: function value() {
            if ((0, _ramda.isNil)((0, _ramda.pathOr)(null, ["nav", "lowMktNavPrice"], _this3.props))) {
              return "-";
            }
            return _formatted_number2.default.prototype.numberFormatter(_currency_utility2.default.convertToCurrencyForNav(_this3.props.nav.lowMktNavPrice, _this3.props.nav.currencyCode, _this3.props.fundTypeCode, _this3.props.country, _this3.props.navDecimalPoints), _this3.props.numberFormat);
          }
        },
        "VIIV": {
          label: 'VIIV',
          dataTest: 'fund-stats-verified-intra-day-value',
          key: FundStatsCard.addPrintSuffix('fund-stats-verified-intra-day-value', isPrint),
          date: navDate,
          value: _currency_utility2.default.convertToCurrency(this.props.verifiedIntraDayValue, this.props.currencyCode)
        },
        "PREMIUM_DISCOUNT_PERCENTAGE": {
          label: _string_utility2.default.renderFormattedLabel('Discount/Premium', "fund-stats-premium-discount-label"),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "Discount/Premium", "fund-stats-premium-discount-label"),
          dataTest: 'fund-stats-premium-discount-percentage',
          key: FundStatsCard.addPrintSuffix('fund-stats-premium-discount-percentage', isPrint),
          date: marketPriceDate,
          shouldUseOnForDateLabel: false,
          value: _number_utility2.default.formatToPercentWith2FixedDecimals(this.props.marketPrice.premiumDiscountPercentage),
          disclosure: this.hasDisclosure('pdpDataPointDiscountPremium'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint
        },
        "PROXY_OVERLAP": {
          label: _string_utility2.default.renderFormattedLabel('Proxy Overlap', "fund-stats-proxy-etf-overlap-label"),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "Proxy Overlap", "fund-stats-proxy-etf-overlap-label"),
          dataTest: 'fund-stats-proxy-etf-overlap',
          key: FundStatsCard.addPrintSuffix('fund-stats-proxy-etf-overlap', isPrint),
          date: this.props.proxyPerfRiskEffectiveDate,
          shouldUseOnForDateLabel: false,
          value: _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(this.props.proxyOverlap),
          disclosure: this.hasDisclosure('pdpDataPointProxyOverlap'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint
        },
        "PROXY_TRACKING_ERROR": {
          label: _string_utility2.default.renderFormattedLabel('Proxy Tracking Error', "fund-stats-proxy-etf-tracking-error-label"),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "Proxy Tracking Error", "fund-stats-proxy-etf-tracking-error-label"),
          dataTest: 'fund-stats-proxy-etf-tracking-error',
          key: FundStatsCard.addPrintSuffix('fund-stats-proxy-etf-tracking-error', isPrint),
          date: this.props.proxyPerfRiskEffectiveDate,
          shouldUseOnForDateLabel: false,
          value: _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(this.props.proxyTrackingError),
          disclosure: this.hasDisclosure('pdpDataPointProxyTrackingError'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint
        },
        "YTD": {
          label: _string_utility2.default.renderFormattedLabel('YTD', "pdp-fund-stats-ytd-label", { breakingLine: _react2.default.createElement('br', null) }),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "YTD", "pdp-fund-stats-ytd-label"),
          dataTest: 'fund-stats-ytd-nav-change-percentage',
          key: FundStatsCard.addPrintSuffix('fund-stats-ytd-nav-change-percentage', isPrint),
          disclosure: this.hasDisclosure('pdpSummaryYtdPopUp'),
          tooltip: this.props.tooltip,
          date: this.props.ytdPercentage.ytdDate,
          shouldUseOnForDateLabel: false,
          suppress: (0, _ramda.isNil)(this.props.ytdPercentage.ytdPercentage),
          value: _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(this.props.ytdPercentage.ytdPercentage, '-', _collection_utility.CollectionUtility.includes(this.props.visibleData.formattingRules, 'FUND_STATS_YTD_WITH_1_DP') ? 1 : 2)
        },
        "SINCE_INCEPTION_RETURN": {
          label: _string_utility2.default.renderFormattedLabel("Since Inception Return", "pdp-fund-stats-since-inception-return-label"),
          dataTest: 'fund-stats-since-inception-return',
          key: FundStatsCard.addPrintSuffix('fund-stats-since-inception-return', isPrint),
          date: (0, _ramda.isNil)(sinceInceptionReturn) ? null : sinceInceptionReturn.performanceReturnEffectiveDate,
          value: _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(!(0, _ramda.isNil)(this.props.fund) && !(0, _ramda.isNil)(oneYrAnnualized) && !(0, _ramda.isNil)(oneYrAnnualized.annualizedNoLoadReturnPercentage) ? sinceInceptionReturn.annualizedNoLoadReturnPercentage : sinceInceptionReturn.cumulativeNoLoadPercentage),
          suppressIfNull: true
        },
        "MARKET_PRICE_RETURNS": {
          label: _string_utility2.default.renderFormattedLabel('Market Price Returns', "fund-stats-market-price-label"),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "Market Price Returns", "fund-stats-market-price-label"),
          dataTest: 'fund-stats-market-price',
          key: FundStatsCard.addPrintSuffix('fund-stats-market-price', isPrint),
          disclosure: this.hasDisclosure('pdpDataPointMarketPriceReturn'),
          tooltip: this.props.tooltip,
          date: this.props.marketPriceReturn.marketPriceReturnDate,
          shouldUseOnForDateLabel: false,
          suppress: (0, _ramda.isNil)(this.props.marketPriceReturn.marketPriceReturnPercentage),
          value: _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(this.props.marketPriceReturn.marketPriceReturnPercentage),
          breakpoint: this.props.breakpoint
        },
        "change_closing_price": {
          label: 'Change in Closing Price',
          dataTest: 'fund-stats-market-price-change',
          key: FundStatsCard.addPrintSuffix('fund-stats-market-price-change', isPrint),
          value: _currency_utility2.default.convertToCurrency(this.props.marketPrice.changeAmount, this.props.currencyCode)
        },
        "change_closing_price_percentage": {
          label: 'Change in Closing Price %',
          dataTest: 'fund-stats-market-price-change-percentage',
          key: FundStatsCard.addPrintSuffix('fund-stats-market-price-change-percentage', isPrint),
          value: _number_utility2.default.formatToPercentWith2FixedDecimals(this.props.marketPrice.changePercentage)
        },
        "MEDIAN_BID_ASK_SPREAD_VALUE": {
          label: _string_utility2.default.renderFormattedLabel('Median Bid/Ask Spread', "fund-stats-median_bid-ask-spread-value-label"),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "Median Bid/Ask Spread", "fund-stats-median_bid-ask-spread-value-label"),
          dataTest: 'fund-stats-median_bid-ask-spread-value',
          date: navDate,
          key: FundStatsCard.addPrintSuffix('fund-stats-median_bid-ask-spread-value', isPrint),
          disclosure: this.hasDisclosure('pdpDataPointMedianBidAskSpread'),
          tooltip: this.props.tooltip,
          value: _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(this.props.nav.medianBidAskSpreadValue),
          suppressIfNull: FundStatsCard.isValueMissing(this.props.nav.medianBidAskSpreadValue),
          breakpoint: this.props.breakpoint
        },
        "YTD_WITH_LOAD": {
          label: 'YTD (Total Return w/Load)',
          dataTest: 'fund-stats-ytd-nav-change-percentage-with-load',
          key: FundStatsCard.addPrintSuffix('fund-stats-ytd-nav-change-percentage-with-load', isPrint),
          date: this.props.ytdPercentage.ytdDate,
          shouldUseOnForDateLabel: false,
          suppress: (0, _ramda.and)((0, _ramda.isNil)(this.props.ytdPercentage.salesChargeAdjustedYtdPercentage), !(0, _fund_utility.isUSEtfFund)(this.props.country, this.props.fundTypeCode)),
          value: _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(this.props.ytdPercentage.salesChargeAdjustedYtdPercentage)
        },
        "DAILY_LIQUID_ASSETS": {
          label: 'Daily Liquid Assets',
          labelText: 'Daily Liquid Assets',
          dataTest: 'fund-stats-daily-liquid-assets',
          key: FundStatsCard.addPrintSuffix('fund-stats-daily-liquid-assets', isPrint),
          date: this.props.fundValuationDate,
          shouldUseOnForDateLabel: false,
          value: _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(this.props.liquidityDailyPercentage),
          disclosure: this.hasDisclosure('pdpDataPointDailyLiquidAssets'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint
        },
        "WEEKLY_LIQUID_ASSETS": {
          label: 'Weekly Liquid Assets',
          labelText: 'Weekly Liquid Assets',
          dataTest: 'fund-stats-weekly-liquid-assets',
          key: FundStatsCard.addPrintSuffix('fund-stats-weekly-liquid-assets', isPrint),
          date: this.props.fundValuationDate,
          shouldUseOnForDateLabel: false,
          value: _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(this.props.liquidityWeeklyPercentage),
          disclosure: this.hasDisclosure('pdpDataPointWeeklyLiquidAssets'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint
        },

        "WAM": {
          label: _string_utility2.default.renderFormattedLabel('WAM (days)', 'pdp-fund-stats-wam-days-label'),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "WAM (days)", "pdp-fund-stats-wam-days-label"),
          dataTest: 'fund-stats-wam',
          key: FundStatsCard.addPrintSuffix('fund-stats-wam', isPrint),
          date: this.props.fundShareClassValuationEffectiveDate,
          shouldUseOnForDateLabel: false,
          value: _number_utility2.default.convertToAmountWithPreciseRounding(this.props.wam, 0),
          disclosure: this.hasDisclosure('pdpDataPointWam'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint
        },
        "WAL": {
          label: _string_utility2.default.renderFormattedLabel('WAL (days)', 'pdp-fund-stats-wal-days-label'),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "WAL (days)", "pdp-fund-stats-wal-days-label"),
          dataTest: 'fund-stats-wal',
          key: FundStatsCard.addPrintSuffix('fund-stats-wal', isPrint),
          date: this.props.fundShareClassValuationEffectiveDate,
          shouldUseOnForDateLabel: false,
          value: _number_utility2.default.convertToAmountWithPreciseRounding(this.props.wal, 0),
          disclosure: this.hasDisclosure('pdpDataPointWal'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint
        },
        "NET_ASSET_CLASS": {
          label: 'Share Class Assets',
          dataTest: 'net-asset-class',
          key: FundStatsCard.addPrintSuffix('net-asset-class', isPrint),
          date: this.props.fundShareClassValuationEffectiveDate,
          shouldUseOnForDateLabel: false,
          value: _currency_utility2.default.convertToCurrencyWithScaleSuffixAnd2DecimalsWithNoRounding(this.props.netGrossAssetClass, this.props.currencyCode)
        },
        "DAILY_HIGH": {
          label: _string_utility2.default.renderFormattedLabel('Daily High', 'fund-stats-daily-high-label'),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "Daily High", "fund-stats-daily-high-label"),
          dataTest: 'fund-stats-daily-high',
          key: FundStatsCard.addPrintSuffix('fund-stats-daily-high', isPrint),
          date: navDate,
          shouldUseOnForDateLabel: false,
          value: _currency_utility2.default.convertToCurrency(this.props.marketPrice.dailyHighPrice, this.props.currencyCode),
          disclosure: this.hasDisclosure('pdpDataPointDailyHigh'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint
        },
        "DAILY_LOW": {
          label: _string_utility2.default.renderFormattedLabel('Daily Low', 'fund-stats-daily-low-label'),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "Daily Low", "fund-stats-daily-low-label"),
          dataTest: 'fund-stats-daily-low',
          key: FundStatsCard.addPrintSuffix('fund-stats-daily-low', isPrint),
          date: navDate,
          shouldUseOnForDateLabel: false,
          value: _currency_utility2.default.convertToCurrency(this.props.marketPrice.dailyLowPrice, this.props.currencyCode),
          disclosure: this.hasDisclosure('pdpDataPointDailyLow'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint
        },
        "NET_ASSETS_FUND": {
          label: _string_utility2.default.renderFormattedLabel('Fund Assets', "pdp-fund-stats-fund-assets-label", { fundTypeCode: this.props.fundTypeCode.replace(/\s/g, '') }),
          dataTest: 'net-asset-fund',
          key: FundStatsCard.addPrintSuffix('net-asset-fund', isPrint),
          date: this.props.aum.date,
          shouldUseOnForDateLabel: false,
          value: _currency_utility2.default.convertToCurrencyWithScaleSuffixAnd2DecimalsWithNoRounding(this.props.aum.netAsset, this.props.currencyCode)
        },
        "TOTAL_ASSET_VALUE": {
          label: _string_utility2.default.renderFormattedLabel('Total Asset Value', "fund-stats-total-assetvalue-label", { fundTypeCode: this.props.fundTypeCode.replace(/\s/g, '') }),
          dataTest: 'fund-stats-total-asset-value',
          key: FundStatsCard.addPrintSuffix('fund-stats-total-asset-value', isPrint),
          date: totalAsset.date,
          shouldUseOnForDateLabel: false,
          value: _currency_utility2.default.convertToCurrencyWithScaleSuffixAnd2DecimalsWithNoRounding(totalAsset.value, this.props.currencyCode),
          breakpoint: this.props.breakpoint
        },
        "LEVERAGE_RATIO": {
          label: _string_utility2.default.renderFormattedLabel('Leverage Ratio', "fund-stats-leverage-ratio-label", { fundTypeCode: this.props.fundTypeCode.replace(/\s/g, '') }),
          dataTest: 'fund-stats-leverage-ratio',
          key: FundStatsCard.addPrintSuffix('fund-stats-leverage-ratio', isPrint),
          date: leverageRatio.date,
          shouldUseOnForDateLabel: false,
          value: _number_utility2.default.formatToPercentWithoutDecimalPoints(leverageRatio.value),
          breakpoint: this.props.breakpoint
        },
        "DAILY_DIVIDEND_FACTOR": {
          label: 'Daily Distribution Rate',
          dataTest: 'fund-stats-daily-dividend-factor',
          key: FundStatsCard.addPrintSuffix('fund-stats-daily-dividend-factor', isPrint),
          date: this.props.fundShareClassValuationEffectiveDate,
          shouldUseOnForDateLabel: false,
          value: _string_utility2.default.displayValue(this.props.dailyDividendFactor)
        },
        "SHARES_OUTSTANDING": {
          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pdp-label-shares-outstanding', defaultMessage: 'Shares Outstanding' }),
          dataTest: 'fund-stats-shares-outstanding',
          key: FundStatsCard.addPrintSuffix('fund-stats-shares-outstanding', isPrint),
          date: this.props.fundShareClassValuationEffectiveDate,
          shouldUseOnForDateLabel: false,
          value: !this.props.sharesOutstanding ? '-' : _formatted_number2.default.prototype.numberFormatter(_number_utility2.default.convertToNumberWithCommas(this.props.sharesOutstanding), this.props.numberFormat)
        },
        "EXCHANGE_VOLUME": {
          label: _string_utility2.default.renderFormattedLabel('Exchange Volume', "fund-stats-exchange-volume-label"),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "Exchange Volume", "fund-stats-exchange-volume-label"),
          dataTest: 'fund-stats-exchange-volume',
          key: FundStatsCard.addPrintSuffix('fund-stats-exchange-volume', isPrint),
          extraHeight: '-30',
          date: navDate,
          shouldUseOnForDateLabel: false,
          value: _string_utility2.default.displayValue((0, _fund_utility.isAUEtfFund)(this.props.country, this.props.fundTypeCode) || (0, _fund_utility.isCAEtfFund)(this.props.country, this.props.fundTypeCode) ? _number_utility2.default.convertToNumberWithCommas(this.props.exchangeVolume) : this.props.exchangeVolume),
          disclosure: this.hasDisclosure('pdpDataPointETFExchangeVolume'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint
        },
        "NUMBER_OF_HOLDINGS": {
          label: _string_utility2.default.renderFormattedLabel('Number of Holdings', 'pdp-overview-fund-stats-no-of-holdings-label'),
          dataTest: 'fund-stats-number-of-holdings',
          key: FundStatsCard.addPrintSuffix('fund-stats-number-of-holdings', isPrint),
          date: this.props.numberOfHoldingsEffectiveDate,
          shouldUseOnForDateLabel: false,
          value: (0, _ramda.isNil)(this.props.numberOfHoldings) ? '-' : _number_utility2.default.convertToNumberWithCommas(this.props.numberOfHoldings),
          suppress: (0, _ramda.and)(this.props.fundTypeCode === 'Mutual Fund', (0, _ramda.isNil)(this.props.fundName) ? false : this.props.fundName.search('SmartRetirement') !== -1 || (0, _ramda.and)(this.props.fundTypeCode === '529 Plans', (0, _ramda.isNil)(this.props.numberOfHoldings)))
        },
        "NUMBER_OF_INVESTMENTS": {
          label: _string_utility2.default.renderFormattedLabel('Number of Investments', 'pdp-overview-fund-stats-no-of-investments-label'),
          dataTest: 'fund-stats-number-of-investments',
          key: FundStatsCard.addPrintSuffix('fund-stats-number-of-investments', isPrint),
          date: this.props.numberOfInvestmentsEffectiveDate,
          shouldUseOnForDateLabel: false,
          value: (0, _ramda.isNil)(this.props.numberOfInvestments) ? '-' : _number_utility2.default.convertToNumberWithCommas(this.props.numberOfInvestments),
          suppress: !(0, _ramda.includes)("NUMBER_OF_INVESTMENTS", _functional_utility2.default.pathOrEmptyArray(["visibleData", "visibleFundStats"], this.props))
        },
        "DAILY_YIELD": {
          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pdp-label-daily-yield', defaultMessage: 'Daily Yield' }),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "Daily Yield", "pdp-label-daily-yield"),
          dataTest: 'fund-stats-daily-yield',
          key: FundStatsCard.addPrintSuffix('fund-stats-daily-yield', isPrint),
          date: this.props.dailyYield.effectiveDate,
          shouldUseOnForDateLabel: false,
          value: _formatted_number2.default.prototype.numberFormatter(_number_utility2.default.convertDecimalToPercentWith2FixedDecimals(this.props.dailyYield.oneDayCurrentYield), this.props.numberFormat),
          disclosure: this.hasDisclosure('pdpDataPoint1daycurrentyield'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint
        },
        "SEVEN_DAY_SEC_YIELD_SUBSIDIZED": {
          label: '7 Day SEC Yield',
          dataTest: 'fund-stats-7-day-sec-yield',
          key: FundStatsCard.addPrintSuffix('fund-stats-7-day-sec-yield', isPrint),
          suppress: (0, _ramda.and)((0, _ramda.isNil)(this.props.dailyYield.sevenDaySecYield), this.props.fundTypeCode === 'Mutual Fund'),
          date: this.props.dailyYield.effectiveDate,
          shouldUseOnForDateLabel: false,
          value: _number_utility2.default.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100(this.props.dailyYield.sevenDaySecYield)
        },
        "SEVEN_DAY_SEC_YIELD_UNNSUBSIDIZED": {
          label: '7 Day SEC Yield Unsubsidized',
          dataTest: 'fund-stats-7-day-unsub-sec-yield',
          key: FundStatsCard.addPrintSuffix('fund-stats-7-day-unsub-sec-yield', isPrint),
          suppress: (0, _ramda.and)((0, _ramda.isNil)(this.props.dailyYield.sevenDayUnsubSecYield), this.props.fundTypeCode === 'Mutual Fund'),
          date: this.props.dailyYield.effectiveDate,
          shouldUseOnForDateLabel: false,
          value: _number_utility2.default.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100(this.props.dailyYield.sevenDayUnsubSecYield)
        },

        "YIELD_SEVEN_DAY_AVERAGE_YIELD": {
          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pdp-label-seven-day-yield', defaultMessage: '7 Day Average Yield' }),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "7 Day Average Yield", "pdp-label-seven-day-yield"),
          dataTest: 'fund-stats-7-day-average-yield',
          key: FundStatsCard.addPrintSuffix('fund-stats-7-day-average-yield', isPrint),
          suppress: (0, _ramda.and)((0, _ramda.isNil)(this.props.dailyYield.sevenDayCurrentYield), this.props.fundTypeCode === 'Mutual Fund'),
          date: this.props.dailyYield.effectiveDate,
          shouldUseOnForDateLabel: false,
          value: _formatted_number2.default.prototype.numberFormatter(_number_utility2.default.convertDecimalToPercentWith2FixedDecimals(this.props.dailyYield.sevenDayCurrentYield), this.props.numberFormat),
          disclosure: this.hasDisclosure('pdpDataPoint7daycurrentyield'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint
        },
        "YIELD_THIRTY_DAY_AVERAGE_YIELD": {
          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pdp-label-thirty-day-yield', defaultMessage: 'Thirty day current yield' }),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "Thirty day current yield", "pdp-label-thirty-day-yield"),
          dataTest: 'fund-stats-30-day-average-yield',
          key: FundStatsCard.addPrintSuffix('fund-stats-30-day-average-yield', isPrint),
          date: this.props.dailyYield.effectiveDate,
          shouldUseOnForDateLabel: false,
          value: (0, _ramda.isNil)(this.props.dailyYield.thirtyDayCurrentYield) ? '-' : _formatted_number2.default.prototype.numberFormatter(_number_utility2.default.convertDecimalToPercentWith2FixedDecimals(this.props.dailyYield.thirtyDayCurrentYield), this.props.numberFormat),
          disclosure: this.hasDisclosure('pdpDataPoint30daycurrentyield'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint
        },
        "THIRTY_DAY_SEC_YIELD_SUBSIDIZED": {
          label: _string_utility2.default.renderFormattedLabel('30 Day SEC Yield', 'pdp-fund-stats-30-days-sec-yield-label'),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "30 Day SEC Yield", "pdp-fund-stats-30-days-sec-yield-label"),
          dataTest: 'fund-stats-30-day-sec-yield',
          key: FundStatsCard.addPrintSuffix('fund-stats-30-day-sec-yield', isPrint),
          suppressIfNull: true,
          date: this.props.yieldMonthEnd.effectiveDate,
          shouldUseOnForDateLabel: false,
          disclosure: this.hasDisclosure('pdpSummary30DaySECYieldPopUp'),
          tooltip: this.props.tooltip,
          value: _number_utility2.default.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100(this.props.yieldMonthEnd.thirtyDaySecYield)
        },
        "THIRTY_DAY_SEC_YIELD_UNSUBSIDIZED": {
          label: _string_utility2.default.renderFormattedLabel('30 Day SEC Yield Unsubsidized', 'pdp-fund-stats-30-days-sec-yield-unsubsidized-label'),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "30 Day SEC Yield Unsubsidized", "pdp-fund-stats-30-days-sec-yield-unsubsidized-label"),
          dataTest: 'fund-stats-30-day-unsub-sec-yield',
          key: FundStatsCard.addPrintSuffix('fund-stats-30-day-unsub-sec-yield', isPrint),
          suppressIfNull: true,
          date: this.props.yieldMonthEnd.effectiveDate,
          shouldUseOnForDateLabel: false,
          disclosure: this.hasDisclosure('pdpSummary30DaySECYieldPopUp'),
          tooltip: this.props.tooltip,
          value: _number_utility2.default.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100(this.props.yieldMonthEnd.thirtyDayUnsubSecYield),
          breakpoint: this.props.breakpoint
        },
        "YIELD_TO_MATURITY_GROSS": {
          label: _string_utility2.default.renderFormattedLabel('Yield to Maturity Gross', 'pdp-fund-stats-ytm-gross-label'),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "Yield to Maturity Gross", "pdp-fund-stats-ytm-gross-label"),
          dataTest: 'fund-stats-ytm-gross',
          key: FundStatsCard.addPrintSuffix('fund-stats-ytm-gross', isPrint),
          suppress: (0, _ramda.isNil)(grossYieldToMaturity.value) || (0, _ramda.isNil)(this.props.netYieldToMaturity),
          date: grossYieldToMaturity.date,
          shouldUseOnForDateLabel: false,
          disclosure: this.hasDisclosure('pdpSummaryYtmPopUp'),
          tooltip: this.props.tooltip,
          value: _number_utility2.default.formatToPercentWith2FixedDecimals(grossYieldToMaturity.value),
          breakpoint: this.props.breakpoint
        },
        "YIELD_TO_MATURITY_NET": {
          label: _string_utility2.default.renderFormattedLabel('Yield to Maturity Net', 'pdp-fund-stats-ytm-net-label'),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "Yield to Maturity Net", "pdp-fund-stats-ytm-net-label"),
          dataTest: 'fund-stats-ytm-net',
          key: FundStatsCard.addPrintSuffix('fund-stats-ytm-net', isPrint),
          suppress: (0, _ramda.isNil)(grossYieldToMaturity.value) || (0, _ramda.isNil)(this.props.netYieldToMaturity),
          date: this.props.netYieldToMaturityEffectiveDate,
          shouldUseOnForDateLabel: false,
          disclosure: this.hasDisclosure('pdpSummaryYtmPopUp'),
          tooltip: this.props.tooltip,
          value: _number_utility2.default.formatToPercentWith2FixedDecimals(this.props.netYieldToMaturity),
          breakpoint: this.props.breakpoint
        },
        "DAILY_THIRTY_DAY_SEC_YIELD": {
          label: _string_utility2.default.renderFormattedLabel('Daily - 30 Day SEC Yield', 'pdp-fund-stats-daily-30-days-sec-yield-label'),
          dataTest: 'fund-stats-daily-30-day-sec-yield',
          key: FundStatsCard.addPrintSuffix('fund-stats-daily-30-day-sec-yield', isPrint),
          suppressIfNull: true,
          date: this.props.secYield.effectiveDate,
          shouldUseOnForDateLabel: false,
          value: _number_utility2.default.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100(this.props.secYield.thirtyDaySecYield)
        },
        "ETF_DAILY_THIRTY_DAY_SEC_YIELD": {
          label: _string_utility2.default.renderFormattedLabel('Daily - 30 Day SEC Yield', 'pdp-fund-stats-daily-30-days-sec-yield-label'),
          dataTest: 'fund-stats-daily-30-day-sec-yield',
          key: FundStatsCard.addPrintSuffix('fund-stats-daily-30-day-sec-yield', isPrint),
          suppressIfNull: true,
          date: (0, _ramda.isNil)(this.props.etfSecYield) ? null : this.props.etfSecYield.effectiveDate,
          shouldUseOnForDateLabel: false,
          value: (0, _ramda.isNil)(this.props.etfSecYield) ? null : _number_utility2.default.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100(this.props.etfSecYield.thirtyDaySecYield)
        },
        "DAILY_THIRTY_DAY_SEC_YIELD_UNSUBSIDIZED": {
          label: _string_utility2.default.renderFormattedLabel('Daily - 30 Day SEC Yield Unsubsidized', 'pdp-fund-stats-daily-30-days-sec-yield-unsubsidized-label'),
          dataTest: 'fund-stats-daily-30-day-unsub-sec-yield',
          key: FundStatsCard.addPrintSuffix('fund-stats-daily-30-day-unsub-sec-yield', isPrint),
          suppressIfNull: true,
          date: this.props.secYield.effectiveDate,
          shouldUseOnForDateLabel: false,
          value: _number_utility2.default.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100(this.props.secYield.thirtyDayUnsubSecYield)
        },
        "ETF_DAILY_THIRTY_DAY_SEC_YIELD_UNSUBSIDIZED": {
          label: _string_utility2.default.renderFormattedLabel('Daily - 30 Day SEC Yield Unsubsidized', 'pdp-fund-stats-daily-30-days-sec-yield-unsubsidized-label'),
          dataTest: 'fund-stats-daily-30-day-unsub-sec-yield',
          key: FundStatsCard.addPrintSuffix('fund-stats-daily-30-day-unsub-sec-yield', isPrint),
          suppressIfNull: true,
          date: (0, _ramda.isNil)(this.props.etfSecYield) ? null : this.props.etfSecYield.effectiveDate,
          shouldUseOnForDateLabel: false,
          value: (0, _ramda.isNil)(this.props.etfSecYield) ? null : _number_utility2.default.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100(this.props.etfSecYield.thirtyDayUnsubSecYield)
        },
        "TWELVE_MONTH_ROLLING_DIVIDEND_YIELD": {
          label: _string_utility2.default.renderFormattedLabel('12-Month Rolling Dividend Yield', 'pdp-fund-stats-12-month-rolling-dividend-yield-label'),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "12-Month Rolling Dividend Yield", "pdp-fund-stats-12-month-rolling-dividend-yield-label"),
          dataTest: 'fund-stats-twelve-rolling-dividend-yield',
          key: FundStatsCard.addPrintSuffix('fund-stats-twelve-rolling-dividend-yield', isPrint),
          suppressIfNull: !(0, _fund_utility.isAUEtfFund)(this.props.country, this.props.fundTypeCode),
          date: this.get12MonthRollingDividendYieldDate(),
          shouldUseOnForDateLabel: false,
          value: this.get12MonthRollingDividendYieldValue(),
          disclosure: this.hasDisclosure((0, _fund_utility.isAUEtfFund)(this.props.country, this.props.fundTypeCode) ? 'pdpDataPointRollingDistributionYield' : 'pdpDataPointRollingDividendYield'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint
        },
        "TAX_EQUIVALENT_YIELD": {
          label: 'Tax Equivalent Yield',
          labelText: 'Tax Equivalent Yield',
          dataTest: 'fund-stats-tax-equivalent-yield',
          key: FundStatsCard.addPrintSuffix('fund-stats-tax-equivalent-yield', isPrint),
          extraHeight: '30',
          suppressIfNull: true,
          date: this.props.yieldMonthEnd.effectiveDate,
          shouldUseOnForDateLabel: false,
          value: _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(this.props.yieldMonthEnd.taxEquivalentYieldAt35Percentage),
          disclosure: this.hasDisclosure('pdpDataPointTaxEquivalentYield'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint
        },
        "TAXABLE_EQUIVALENT_YIELD": {
          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pdp-fund-stats-taxable-equivalent-yield', defaultMessage: 'Taxable Equivalent Yield' }),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "Taxable Equivalent Yield", "pdp-fund-stats-taxable-equivalent-yield"),
          dataTest: 'fund-stats-taxable-equivalent-yield',
          key: FundStatsCard.addPrintSuffix('fund-stats-taxable-equivalent-yield', isPrint),
          date: this.props.secYield.effectiveDate,
          shouldUseOnForDateLabel: false,
          value: _formatted_number2.default.prototype.numberFormatter(_number_utility2.default.convertDecimalToPercentWith2FixedDecimals(this.props.secYield.taxEquivalentYield), this.props.numberFormat),
          disclosure: this.hasDisclosure('pdpDataPointTaxEquivalentYield'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint
        },
        "DIVIDEND_YIELD": {
          label: _string_utility2.default.renderFormattedLabel('Dividend Yield', 'pdp-fund-stats-dividend-yield-label'),
          dataTest: 'fund-stats-dividend-yield',
          key: FundStatsCard.addPrintSuffix('fund-stats-dividend-yield', isPrint),
          suppressIfNull: true,
          date: this.props.yieldMonthEnd.effectiveDate,
          shouldUseOnForDateLabel: false,
          value: this.getDividendYield(),
          breakpoint: this.props.breakpoint
        },
        "IMA_SNP": {
          label: 'S&P Ratings',
          labelText: 'S&P Ratings',
          dataTest: 's-and-p-rating',
          key: FundStatsCard.addPrintSuffix('s-and-p-rating', isPrint),
          suppressIfNull: true,
          date: this.getRatings(this.props.fundIndustryCreditRatings, "IMA_SNP", "fundIndustryRatingDate"),
          shouldUseOnForDateLabel: false,
          value: this.getRatings(this.props.fundIndustryCreditRatings, "IMA_SNP", "creditRatingName"),
          tooltip: this.props.tooltip,
          disclosure: this.hasDisclosure('pdpDataPointSPRatings')
        },
        "IMA_MOODY": {
          label: "Moody's Rating",
          labelText: "Moody's Rating",
          dataTest: 'moodys-rating',
          key: FundStatsCard.addPrintSuffix('moodys-rating', isPrint),
          suppressIfNull: true,
          date: this.getRatings(this.props.fundIndustryCreditRatings, "IMA_MOODY", "fundIndustryRatingDate"),
          shouldUseOnForDateLabel: false,
          value: this.getRatings(this.props.fundIndustryCreditRatings, "IMA_MOODY", "creditRatingName"),
          tooltip: this.props.tooltip,
          disclosure: this.hasDisclosure('pdpDataPointMoodysRating')
        },
        "IMA_FITCH": {
          label: 'Fitch',
          labelText: 'Fitch',
          dataTest: 'fitch-rating',
          key: FundStatsCard.addPrintSuffix('fitch-rating', isPrint),
          suppressIfNull: true,
          date: this.getRatings(this.props.fundIndustryCreditRatings, "IMA_FITCH", "fundIndustryRatingDate"),
          shouldUseOnForDateLabel: false,
          value: this.getRatings(this.props.fundIndustryCreditRatings, "IMA_FITCH", "creditRatingName"),
          tooltip: this.props.tooltip,
          disclosure: this.hasDisclosure('pdpDataPointFitch')
        },
        "NON_FAIR_NAV": {
          label: 'Non-Fair Value NAV',
          labelText: 'Non-Fair Value NAV',
          dataTest: 'fund-stats-non-fair-nav',
          key: FundStatsCard.addPrintSuffix('non-fair-nav', isPrint),
          suppressIfNull: true,
          date: (0, _ramda.pathOr)(null, ["nonFairValueNAVDate"], this.props.nonFairNav),
          shouldUseOnForDateLabel: false,
          value: _currency_utility2.default.convertToCurrency((0, _ramda.pathOr)(null, ["nonFairValueNAVPrice"], this.props.nonFairNav), this.props.currencyCode),
          disclosure: this.hasDisclosure('pdpDataPointETFNonFairValueNAV'),
          tooltip: this.props.tooltip,
          breakpoint: this.props.breakpoint
        },
        "THREE_PM_NAV": {
          label: '3:00 PM EST NAV',
          labelText: '3:00 PM EST NAV',
          dataTest: 'fund-stats-three-pm-nav',
          key: FundStatsCard.addPrintSuffix('three-pm-nav', isPrint),
          suppressIfNull: true,
          date: (0, _ramda.pathOr)(null, ["nonFairValueNAVDate"], this.props.threePMNav),
          shouldUseOnForDateLabel: false,
          value: _currency_utility2.default.convertToCurrency((0, _ramda.pathOr)(null, ["nonFairValueNAVPrice"], this.props.threePMNav), this.props.currencyCode),
          tooltip: this.props.tooltip,
          disclosure: this.hasDisclosure('pdpDataPointETFNonFairValueNAV'),
          breakpoint: this.props.breakpoint
        },
        "FISCAL_YEAR_END": {
          label: _string_utility2.default.renderFormattedLabel('Fiscal year end', 'pdp-overview-fund-stats-fiscal-year-end-label'),
          dataTest: 'fund-stats-fiscal-year-end',
          key: FundStatsCard.addPrintSuffix('fund-stats-fiscal-year-end', isPrint),
          value: this.props.fiscalYearEnd
        },
        "UK_REPORTING_STATUS": {
          label: _string_utility2.default.renderFormattedLabel('UK reporting status', 'pdp-overview-fund-stats-uk-reporting-status-label'),
          dataTest: 'uk-reporting-status',
          key: FundStatsCard.addPrintSuffix('uk-reporting-status', isPrint),
          value: _string_utility2.default.getYesOrNo(this.props.ukReportingIndicator)
        },
        "YIELD_AMOUNT": {
          label: 'Yield',
          labelText: 'Yield',
          dataTest: 'fund-stats-yield',
          key: FundStatsCard.addPrintSuffix('fund-stats-yield', isPrint),
          value: _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(this.props.yieldAmount),
          date: this.props.secYield.effectiveDate,
          shouldUseOnForDateLabel: false,
          suppressIfNull: true,
          tooltip: this.props.tooltip,
          disclosure: (0, _ramda.map)(this.hasDisclosure, (0, _ramda.filter)(function (disclosure) {
            return !(0, _ramda.isNil)(_this3.props.disclosure[disclosure]);
          }, ['pdpDataPointYield', 'pdpDataPointYieldIT']))
        },
        "LATEST_DIVIDEND_VALUE": {
          label: _string_utility2.default.renderFormattedLabel('Latest dividend value', "pdp-fund-stats-latest-dividend-value-label"),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "Latest dividend value", "pdp-fund-stats-latest-dividend-value-label"),
          dataTest: 'fund-stats-latest-dividend-value',
          key: FundStatsCard.addPrintSuffix('fund-stats-latest-dividend-value', isPrint),
          value: function value() {
            if ((0, _ramda.isNil)((0, _ramda.pathOr)(null, ["latestDividend", "dividendAmount"], _this3.props))) {
              if (_this3.doesFormattingRulesContains("FUND_STATS_DISPLAY_CUSTOM_NULL_VALUE_FOR_RETAIL_FUNDS_LAST_DISTRIBUTION_DATA")) {
                return _string_utility2.default.renderFormattedLabel('None Paid', "pdp-fund-stats-latest-dividend-null-value-label-for-retail-fund");
              } else {
                return "-";
              }
            }
            if (shouldUseTranslatedMessageToFormatCurrency || _this3.doesFormattingRulesContains('FUND_STATS_NAV_NO_CURRENCY')) {
              var currencyCode = _this3.doesFormattingRulesContains('FUND_STATS_NAV_NO_CURRENCY') ? ' ' : _this3.props.shareclassCurrencyCode;
              return _currency_utility2.default.formatCurrencyInRegionTranslatedFormatAsIs(_this3.props.country, _this3.props.latestDividend.dividendAmount, currencyCode, _this3.props.fundTypeCode);
            } else {
              return _currency_utility2.default.formatNumberForPenceWith2DecimalPlaces(latestDividend);
            }
          },
          date: this.shouldSuppressLastDistributionDate() ? null : (0, _ramda.pathOr)(null, ["latestDividend", "exDate"], this.props),
          shouldUseOnForDateLabel: (0, _ramda.includes)("FUND_STATS_DISPLAY_ON_INSTEAD_OF_AS_OFF", this.props.visibleData.formattingRules),
          suppressIfNull: this.shouldSuppressLastDistributionWithNullData(),
          tooltip: this.props.tooltip,
          disclosure: this.hasDisclosure('pdpDataPointDividend')
        },
        "EX_DIVIDEND_DATE": {
          label: 'Xd date',
          dataTest: 'xd-date',
          key: FundStatsCard.addPrintSuffix('xd-date', isPrint),
          value: _date_formatter2.default.getDateInSlashFormatOrNA(this.props.exDividendDate),
          suppressIfNull: true
        },
        "INCOME_DISTRIBUTION_FREQUENCY": {
          label: _string_utility2.default.renderFormattedLabel('Income distribution frequency', 'pdp-overview-fund-stats-income-dist-frequency-label'),
          dataTest: 'income-distribution-frequency',
          key: FundStatsCard.addPrintSuffix('income-distribution-frequency', isPrint),
          value: this.getIncomeDividendFrequency(this.props.incomeDistributionFrequency),
          suppressIfNull: true
        },
        "INCOME_DISTRIBUTION_DATE": {
          label: 'Income distribution date',
          dataTest: 'income-distribution-date',
          key: FundStatsCard.addPrintSuffix('income-distribution-date', isPrint),
          value: this.props.incomeDistributionDate,
          suppressIfNull: true
        },
        "REPLICATION_METHOD_TYPE": {
          label: _string_utility2.default.renderFormattedLabel('Replication method', 'pdp-overview-fund-stats-replication-method-label'),
          dataTest: 'fund-stats-replication-method',
          key: FundStatsCard.addPrintSuffix('replication-method', isPrint),
          value: this.props.replicationMethodName,
          suppressIfNull: true
        },
        "REBALANCING_FREQUENCY": {
          label: _string_utility2.default.renderFormattedLabel('Rebalancing frequency', 'pdp-overview-fund-stats-rebalancing-frequency-label'),
          dataTest: 'fund-stats-rebalancing-frequency',
          key: FundStatsCard.addPrintSuffix('rebalancing-frequency', isPrint),
          value: this.props.fundRebalancingFrequencyName,
          suppressIfNull: true
        },
        "SECURITY_LENDING_FLAG": {
          label: _string_utility2.default.renderFormattedLabel('Securities lending', 'pdp-overview-fund-stats-securities-lending-flag-label'),
          dataTest: 'fund-stats-securities-lending-flag',
          key: FundStatsCard.addPrintSuffix('securities-lending-flag', isPrint),
          value: _string_utility2.default.getYesOrNo(this.props.securityLendingFlag),
          suppress: !(0, _ramda.includes)("SECURITY_LENDING_FLAG", (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleFundStats"], this.props)) || !this.props.securityLendingFlag
        },
        "COMPANY_BROKERS": {
          label: 'Company Broker(s)',
          dataTest: 'fund-stats-company-brokers',
          key: FundStatsCard.addPrintSuffix('company-brokers', isPrint),
          companyBrokerNames: this.props.companyBrokerNames,
          value: "-"
        },
        "GROSS_ASSETS": {
          label: _string_utility2.default.renderFormattedLabel('Gross assets', "pdp-fund-stats-gross-assets-label"),
          dataTest: 'fund-stats-gross-assets',
          key: FundStatsCard.addPrintSuffix('gross-assets', isPrint),
          value: _currency_utility2.default.getFundSizeBasedOnRules(this.props.visibleData.formattingRules, this.props.country, this.props.netGrossAssetClass, this.props.currencyCode, this.props.numberFormat, this.props.role),
          date: this.props.fundShareClassValuationEffectiveDate,
          shouldUseOnForDateLabel: false
        },
        "CURRENT_SHARE_PRICE": {
          label: 'Current share price',
          dataTest: 'fund-stats-current-share-price',
          key: FundStatsCard.addPrintSuffix('current-share-price', isPrint),
          currentSharePrice: this.props.currentSharePrice,
          value: function value() {
            if ((0, _ramda.isNil)((0, _ramda.pathOr)(null, ["currentSharePrice", "closingPrice"], _this3.props))) {
              return "-";
            }

            return _currency_utility2.default.formatNumberForPenceWith2DecimalPlaces(_this3.props.currentSharePrice.closingPrice);
          },
          date: this.props.currentSharePriceDate,
          shouldUseOnForDateLabel: false
        },
        "NAV_PENCE": {
          label: _string_utility2.default.renderFormattedLabel("NAV", "pdp-fund-stats-nav-label", { fundType: this.props.fundTypeCode }),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "NAV", "pdp-fund-stats-nav-label"),
          dataTest: 'fund-stats-nav-pence',
          key: FundStatsCard.addPrintSuffix('fund-stats-nav-pence', isPrint),
          date: this.props.nav.navEffectiveDate,
          shouldUseOnForDateLabel: false,
          value: _currency_utility2.default.formatNumberForPenceWith2DecimalPlaces(this.props.nav.price),
          disclosure: this.hasDisclosure('pdpSummaryNAV'),
          tooltip: this.props.tooltip
        },
        "QUOTED_PRICE": {
          label: _string_utility2.default.renderFormattedLabel("Quoted price", "pdp-fund-stats-quoted-price-label"),
          labelText: _string_utility2.default.getLocalizedString(this.props.intl, "Quoted price", "pdp-fund-stats-quoted-price-label"),
          dataTest: 'fund-stats-quoted-price',
          key: FundStatsCard.addPrintSuffix('fund-stats-quoted-price', isPrint),
          date: marketPriceDate,
          shouldUseOnForDateLabel: false,
          value: _currency_utility2.default.formatNumberForPenceWith2DecimalPlaces(this.props.nav.price),
          disclosure: this.hasDisclosure('pdpDataPointQuotedPrice'),
          tooltip: this.props.tooltip
        },
        "TOTAL_ANNUAL_DIVIDEND": {
          label: 'Total dividend for last financial year',
          dataTest: 'fund-stats-total-annual-dividend',
          key: FundStatsCard.addPrintSuffix('fund-stats-total-annual-dividend', isPrint),
          value: _currency_utility2.default.formatNumberForPenceWith2DecimalPlaces(this.props.totalAnnualDividend),
          suppressIfNull: true
        },
        "POTENTIAL_GEARING_RANGE": {
          label: 'Potential gearing range',
          dataTest: 'fund-stats-potential-gearing-range',
          key: FundStatsCard.addPrintSuffix('fund-stats-potential-gearing-range', isPrint),
          value: this.props.potentialGearingRange,
          suppressIfNull: true
        },
        "ACTUAL_GEARING": {
          label: 'Actual gearing',
          labelText: 'Actual gearing',
          dataTest: 'fund-stats-actual-gearing',
          key: FundStatsCard.addPrintSuffix('fund-stats-actual-gearing', isPrint),
          date: marketPriceDate,
          shouldUseOnForDateLabel: false,
          value: (0, _ramda.isNil)(this.props.actualGearing) ? '-' : _number_utility2.default.formatToPercentWith2FixedDecimals(this.props.actualGearing),
          tooltip: this.props.tooltip,
          disclosure: this.hasDisclosure('pdpDataPointActualGearing'),
          suppressIfNull: true
        },
        "NAV_CHANGE_AMOUNT_PENCE": {
          label: _string_utility2.default.renderFormattedLabel("-", "pdp-label-nav-display", { fundType: this.props.fundTypeCode }),
          dataTest: 'fund-stats-nav-change-amount-pence',
          key: FundStatsCard.addPrintSuffix('fund-stats-nav-change-amount-pence', isPrint),
          date: this.props.nav.navMovementEffectiveDate,
          shouldUseOnForDateLabel: false,
          value: function value() {
            if ((0, _ramda.isNil)((0, _ramda.pathOr)(null, ["nav", "changeAmount"], _this3.props))) {
              return "-";
            }
            return _currency_utility2.default.formatNumberForPenceWith2DecimalPlaces(_this3.props.nav.changeAmount);
          }
        },
        "TWELVE_MONTH_HIGH_NAV_PENCE": {
          label: _string_utility2.default.renderFormattedLabel('12 Month NAV high', "pdp-fund-stats-twelve-month-high-label", { fundType: this.props.fundTypeCode }),
          dataTest: 'fund-stats-twelve-month-high-nav-pence',
          key: FundStatsCard.addPrintSuffix('fund-stats-twelve-month-high-nav-pence', isPrint),
          date: this.props.nav.highNavPriceDate,
          shouldUseOnForDateLabel: false,
          suppress: this.doesFormattingRulesContains("TWELVE_MONTH_HIGH_NAV_DO_NOT_SUPRESS") ? false : FundStatsCard.isValueMissing(this.props.nav.highNavPrice),
          value: function value() {
            if ((0, _ramda.isNil)((0, _ramda.pathOr)(null, ["nav", "highNavPrice"])(_this3.props))) {
              return "-";
            }
            return _currency_utility2.default.formatNumberForPenceWith2DecimalPlaces(_this3.props.nav.highNavPrice);
          }
        },
        "TWELVE_MONTH_LOW_NAV_PENCE": {
          label: _string_utility2.default.renderFormattedLabel('12 Month NAV low', "pdp-fund-stats-twelve-month-low-label", { fundType: this.props.fundTypeCode }),
          dataTest: 'fund-stats-twelve-month-low-nav-pence',
          key: FundStatsCard.addPrintSuffix('fund-stats-twelve-month-low-nav-pence', isPrint),
          date: this.props.nav.lowNavPriceDate,
          shouldUseOnForDateLabel: false,
          suppress: this.doesFormattingRulesContains("TWELVE_MONTH_HIGH_NAV_DO_NOT_SUPRESS") ? false : FundStatsCard.isValueMissing(this.props.nav.lowNavPrice),
          value: function value() {
            if ((0, _ramda.isNil)((0, _ramda.pathOr)(null, ["nav", "lowNavPrice"], _this3.props))) {
              return "-";
            }
            return _currency_utility2.default.formatNumberForPenceWith2DecimalPlaces(_this3.props.nav.lowNavPrice);
          }
        },
        "ACTIVE_SHARE": {
          label: _string_utility2.default.renderFormattedLabel("Active Share", "pdp-fund-stats-active-share-error-label"),
          dataTest: 'active-share-sub-header',
          key: FundStatsCard.addPrintSuffix('active-share-sub-header', isPrint),
          date: (0, _ramda.pathOr)(null, ["fund", "shareClass", "fundShareclassMonthEndPeriodRisk", "performanceRiskEffectiveDate"], this.props),
          value: function value() {
            if ((0, _ramda.isNil)((0, _ramda.pathOr)(null, ["fund", "shareClass", "fundShareclassMonthEndPeriodRisk", "activeSharePercentage"], _this3.props))) {
              return "-";
            }
            return _number_utility2.default.formatToPercentWithoutDecimalPoints(_this3.props.fund.shareClass.fundShareclassMonthEndPeriodRisk.activeSharePercentage);
          },
          tooltip: this.props.tooltip,
          suppressIfNull: true,
          disclosure: this.hasDisclosure('pdpDataPointActiveShare')
        },
        "TRACKING_ERROR_LABEL": {
          label: _string_utility2.default.renderFormattedLabel("Annual Tracking Error %", "pdp-fund-stats-annual-tracking-error-label"),
          dataTest: 'tracking-error-sub-header',
          key: FundStatsCard.addPrintSuffix('tracking-error-sub-header', isPrint),
          date: this.getAnnualTrackingErrorDate(),
          value: !(0, _ramda.isNil)(this.props.portfolioStatisticalAnalysis) ? this.props.portfolioStatisticalAnalysis.data.filter(function (d) {
            return d.name === "pdp-portfolio-statistical-analysis-label-annual-tracking-error";
          })[0] : " ",
          suppress: this.isSuppressAnnualTrackingError(),
          tooltip: this.props.tooltip,
          disclosure: this.hasDisclosure('pdpDataPointTrackingError'),
          isTrackingError: true
        },
        "DURATION_MATURITY": {
          label: _string_utility2.default.renderFormattedLabel("Duration", "pdp-fund-stats-duration-label"),
          dataTest: 'fund-stats-duration',
          key: FundStatsCard.addPrintSuffix('fund-stats-duration', isPrint),
          date: !(0, _ramda.isNil)(this.props.fundDurationMaturity) ? this.props.fundDurationMaturity.effectiveDate : "-",
          value: this.getFundDurationMaturityDuration(this.props.fundDurationMaturity),
          suppress: (0, _ramda.isNil)(this.props.fundDurationMaturity) || (0, _ramda.isNil)(this.props.fundDurationMaturity.duration)
        }
      };
      return _react2.default.createElement(_fund_stats_data_point2.default, _extends({}, fundStatsMap[key], { country: this.props.country, role: this.props.role, useTooltipWrapper: this.props.useTooltipWrapper,
        numberFormat: this.props.numberFormat, i: i }));
    }
  }, {
    key: 'get12MonthRollingDividendYieldValue',
    value: function get12MonthRollingDividendYieldValue() {
      var _props2 = this.props,
          fundTypeCode = _props2.fundTypeCode,
          country = _props2.country;

      if (!(0, _functional_utility.isNilOrEmpty)((0, _functional_utility.pathOrNull)(["thirtyDaySecYield"], this.props.etfSecYield)) && !(0, _functional_utility.isNilOrEmpty)(this.props.dailyYield.twlvMthSimpleYield) && (0, _fund_utility.isUSEtfFund)(country, fundTypeCode)) {
        return _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(this.props.dailyYield.twlvMthSimpleYield);
      } else if (!(0, _functional_utility.isNilOrEmpty)(this.props.yieldMonthEnd.thirtyDaySecYield)) {
        return _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(this.props.yieldMonthEnd.twlvMthSimpleYield);
      } else if ((0, _fund_utility.isAUEtfFund)(country, fundTypeCode) && this.props.dailyYield != null && this.props.dailyYield.effectiveDate === this.props.latestDividendExDate) {
        return _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(this.props.dailyYield.twlvMthSimpleYield);
      } else {
        return null;
      }
    }
  }, {
    key: 'get12MonthRollingDividendYieldDate',
    value: function get12MonthRollingDividendYieldDate() {
      var _props3 = this.props,
          fundTypeCode = _props3.fundTypeCode,
          country = _props3.country;

      if (!(0, _functional_utility.isNilOrEmpty)((0, _functional_utility.pathOrNull)(["thirtyDaySecYield"], this.props.etfSecYield)) && !(0, _functional_utility.isNilOrEmpty)(this.props.dailyYield.twlvMthSimpleYield) && (0, _fund_utility.isUSEtfFund)(country, fundTypeCode)) {
        return this.props.dailyYield.effectiveDate;
      } else if ((0, _fund_utility.isAUEtfFund)(country, fundTypeCode)) {
        return this.props.dailyYield.effectiveDate === this.props.latestDividendExDate ? (0, _ramda.pathOr)(null, ["latestDividendRecordDate"], this.props) : null;
      } else {
        return this.props.yieldMonthEnd.effectiveDate;
      }
    }
  }, {
    key: 'getAnnualTrackingErrorDate',
    value: function getAnnualTrackingErrorDate() {
      if (!(0, _functional_utility.isNilOrEmpty)(this.props.portfolioStatisticalAnalysis)) {
        return this.props.portfolioStatisticalAnalysis.effectiveDate;
      }
    }
  }, {
    key: 'isSuppressAnnualTrackingError',
    value: function isSuppressAnnualTrackingError() {
      var isSuppressed = true;
      if (!(0, _functional_utility.isNilOrEmpty)(this.props.portfolioStatisticalAnalysis)) {
        this.props.portfolioStatisticalAnalysis.data.forEach(function (item) {
          if (item.name === "pdp-portfolio-statistical-analysis-label-annual-tracking-error") {
            if (item.displayValue !== "-" || item.displaySecondaryValue !== "-" || item.displayTertiaryValue !== "-" || item.displayQuarternaryValue !== "-") {
              isSuppressed = false;
            }
          }
        });
      }
      return isSuppressed;
    }
  }, {
    key: 'shouldSuppressLastDistributionWithNullData',
    value: function shouldSuppressLastDistributionWithNullData() {
      return !this.doesFormattingRulesContains("LATEST_DIVIDEND_VALUE_DO_NOT_SUPRESS") && !this.doesFormattingRulesContains("FUND_STATS_DISPLAY_CUSTOM_NULL_VALUE_FOR_RETAIL_FUNDS_LAST_DISTRIBUTION_DATA");
    }
  }, {
    key: 'shouldSuppressLastDistributionDate',
    value: function shouldSuppressLastDistributionDate() {
      if (this.doesFormattingRulesContains("SUPPRESS_LATEST_DIVIDEND_DATE")) {
        return true;
      }
      if ((0, _ramda.isNil)((0, _ramda.pathOr)(null, ["latestDividend", "dividendAmount"], this.props) && this.doesFormattingRulesContains("FUND_STATS_DISPLAY_CUSTOM_NULL_VALUE_FOR_RETAIL_FUNDS_LAST_DISTRIBUTION_DATA"))) {
        return true;
      }
      return false;
    }
  }, {
    key: 'getDividendYield',
    value: function getDividendYield() {
      var _props4 = this.props,
          yieldMonthEnd = _props4.yieldMonthEnd,
          fundTypeCode = _props4.fundTypeCode,
          country = _props4.country;

      var dividendValue = _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(yieldMonthEnd.dividendYield);
      var thirtyDaySecYieldIsNull = (0, _ramda.isNil)(yieldMonthEnd.thirtyDaySecYield);
      var twelveMonthRollingYieldIsNotNull = !(0, _ramda.isNil)(yieldMonthEnd.twlvMthSimpleYield);

      if ((0, _fund_utility.isUSEtfFund)(country, fundTypeCode) || (0, _fund_utility.isCAEtfFund)(country, fundTypeCode)) {
        return thirtyDaySecYieldIsNull ? null : dividendValue;
      }

      return thirtyDaySecYieldIsNull || twelveMonthRollingYieldIsNotNull ? null : dividendValue;
    }
  }, {
    key: 'getAnnualizedYieldDate',
    value: function getAnnualizedYieldDate() {
      var _props5 = this.props,
          fundTypeCode = _props5.fundTypeCode,
          country = _props5.country;

      if ((0, _fund_utility.isAUEtfFund)(country, fundTypeCode)) {
        return (0, _ramda.pathOr)(null, ["latestAnnualizedYield", "recordDate"], this.props);
      }

      return (0, _ramda.pathOr)(null, ["latestAnnualizedYield", "exDate"], this.props);
    }
  }, {
    key: 'getIncomeDividendFrequency',
    value: function getIncomeDividendFrequency(value) {
      if (this.doesFormattingRulesContains("INCOME_DIVIDEND_FREQUENCY_DISPLAY_AS_IS")) {
        return value ? _string_utility2.default.getLocalizedString(this.props.intl, value, "pdp-overview-fund-stats-income-distribution-freq-val-" + (0, _ramda.toLower)(value)) : null;
      }
      return value ? _string_utility2.default.getLocalizedString(this.props.intl, (0, _ramda.toLower)(value), "pdp-overview-fund-stats-income-distribution-freq-val-" + (0, _ramda.toLower)(value)) : null;
    }
  }, {
    key: 'hasDisclosure',
    value: function hasDisclosure(disclosureKey) {
      return this.props.disclosure[disclosureKey];
    }
  }, {
    key: 'getRatings',
    value: function getRatings(ratings, key, value) {
      if ((0, _ramda.isNil)(ratings) || _collection_utility.CollectionUtility.size(ratings) < 1) {
        return null;
      }

      var ratingsObject = _collection_utility.CollectionUtility.find(ratings, function (item) {
        return item.creditRatingSchemeCode === key;
      });

      if (ratingsObject && ratingsObject[value]) {
        return ratingsObject[value];
      }

      return null;
    }
  }, {
    key: 'getHeaderTitle',
    value: function getHeaderTitle(labelId) {
      return (0, _string_utility3.renderFormattedLabel)('Fund Stats', labelId, { fundType: (0, _functional_utility.isNilOrEmpty)(this.props.fundTypeCode) ? "" : this.props.fundTypeCode.replace(/\s/g, ''), role: this.props.role });
    }
  }, {
    key: 'getFundDurationMaturityDuration',
    value: function getFundDurationMaturityDuration(fundDurationMaturity) {
      if (!(0, _ramda.isNil)(fundDurationMaturity)) {
        var value = _number_utility2.default.convertToAmountWithPreciseRounding(fundDurationMaturity.duration, 2);
        var suffix = value === 1.00 ? ' year' : ' years';
        return value + suffix;
      }
      return "-";
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$disclosure = this.props.disclosure,
          pdpCardFundStatsLargeText = _props$disclosure.pdpCardFundStatsLargeText,
          pdpCardFundStats = _props$disclosure.pdpCardFundStats;

      var labelId = _collection_utility.CollectionUtility.includes(this.props.visibleData.visibleDataPoints, 'SHOW_COMPANY_HEADER') ? "pdp-overview-company-stats" : "pdp-overview-fund-stats";
      var headerTitle = this.getHeaderTitle(labelId);

      return _react2.default.createElement(
        _card_component2.default,
        {
          dataTest: 'fund-stats',
          headerTitle: headerTitle,
          headerTitleId: "fund-stats",
          headerTitleLabel: "",
          headerLabel: "",
          displayStyle: 'width-percent-100 margin-left-0 float-left',
          breakpoint: this.props.breakpoint,
          placementId: "pdpCardFundStats",
          is25PercentCard: true
        },
        _react2.default.createElement(
          'div',
          { className: 'print-hide padding-bottom-5', role: "table", 'aria-labelledby': "fund-stats" },
          this.renderFundStatsData()
        ),
        this.renderPrintColumns(),
        !(0, _ramda.isNil)(pdpCardFundStatsLargeText) && _react2.default.createElement(
          'div',
          {
            className: 'display-inline-block margin-top-15 margin-bottom-0 text-justified position-relative disclaimer margin-horizontal--30 padding-horizontal-24' },
          _react2.default.createElement('span', { 'data-testid': 'funds-stats-large-text',
            dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(pdpCardFundStatsLargeText) } })
        ),
        !(0, _ramda.isNil)(pdpCardFundStats) && mapIndexed(function (disclosure, index) {
          return _react2.default.createElement('div', { 'data-testid': 'funds-stats-disclosure', id: 'funds-stats-disclosure', className: 'text-justified disclaimer margin-horizontal--30 padding-horizontal-24',
            key: index, dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(disclosure) } });
        }, pdpCardFundStats),
        _react2.default.createElement(
          'div',
          { className: 'text-justified disclaimer', 'data-testid': 'fund-stats-print-disclosure',
            style: { "display": "none" } },
          this.renderPrintDisclosures()
        )
      );
    }
  }], [{
    key: 'addPrintSuffix',
    value: function addPrintSuffix(keyStr, isPrint) {
      return '' + keyStr + (isPrint ? "-print" : "");
    }
  }, {
    key: 'isValueMissing',
    value: function isValueMissing(value) {
      return value === "-" || !value;
    }
  }]);

  return FundStatsCard;
}(_react.PureComponent);

exports.default = FundStatsCard;